<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
          flat
          full-width
          title="Карточка пользователя"
        >
          <v-card-actions>
            <v-spacer />
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                    color="blue"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                  Установить пароль
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                      <span class="headline"
                      >Новый пароль</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field
                          v-model="password"
                          type="text"
                          label="Пароль"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="green darken-1" @click="setPassword">
                    Save
                  </v-btn>
                </v-card-actions>

              </v-card>
            </v-dialog>
            <v-btn color="blue darken-1" text @click="UnBuindSubscriber">
              отписать от рассылки
            </v-btn>
          </v-card-actions>
          <v-row v-for="(item, index) in fields" :key="index">
            <v-col>{{ item.title }}</v-col>
            <v-col>{{ item.value }}</v-col>
          </v-row>
        </material-card>
      </v-col>
    </v-row>
    <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackType"
        top
    >
      {{ snackText }}

      <template #action="{ attrs }">
        <v-btn
            v-bind="attrs"
            text
            @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>
<script>
import { getUserProfile, setPassword, unsubscribeEmail } from '../../graphql/users'

export default {
  name: 'UserEdit',
  layout: 'dashboard',
  data () {
    return {
        fields: [],
      dialog: false,
      password: '',
      snack: false,
      snackText: '',
      snackType: 'error'
    }
  },
  apollo: {
    Profile: {
      query: getUserProfile,
      variables () {
        return {
          id: this.$route.params.id
        }
      },
      result ({ data, loading }) {
        if (data?.getUserProfile?.fields) {
          this.fields = data?.getUserProfile?.fields
        }
      }
    }
  },
  methods: {
    setPassword () {
      this.$apollo
          .mutate({
            mutation: setPassword,
            variables: {
              id: this.$route.params.id,
              password: this.password
            }
          })
          .then((data) => {
            this.snack = true
            this.snackType = 'primary'
            this.snackText = 'Пароль установлен'
          })
          .catch((error) => {
            this.snack = true
            this.snackType = 'error'
            this.snackText = error
          })

      this.close()
    },
    close () {
      this.password = ''
      this.dialog = false
    },
    UnBuindSubscriber () {
      this.$apollo
          .mutate({
            mutation: unsubscribeEmail,
            variables: {
              email: this.getField('email')
            }
          })
          .then((data) => {
            this.snack = true
            this.snackType = 'primary'
            this.snackText = data.data.status
          })
          .catch((error) => {
            this.snack = true
            this.snackType = 'error'
            this.snackText = error
          })
    },
    getField (name) {
     return this.fields.filter(item => item.name === name)?.[0]?.value
    }
  }
}
</script>
